"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var SiteMap =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(SiteMap, _React$Component);

  function SiteMap() {
    (0, _classCallCheck2["default"])(this, SiteMap);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SiteMap).apply(this, arguments));
  }

  (0, _createClass2["default"])(SiteMap, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          links = _this$props.links,
          horizontal = _this$props.horizontal,
          bulleted = _this$props.bulleted,
          internalLinkComponent = _this$props.internalLinkComponent;
      return _react["default"].createElement(_semanticUiReact.List, {
        horizontal: horizontal,
        bulleted: bulleted
      }, links.map(function (link) {
        var additionalProps = link.internal ? {
          to: link.slug,
          href: link.slug
        } : {
          href: link.slug
        };
        var linkComponent = link.internal ? internalLinkComponent : 'a';
        return _react["default"].createElement(_semanticUiReact.List.Item, {
          key: link.slug
        }, _react["default"].createElement(_semanticUiReact.List.Content, (0, _extends2["default"])({
          as: linkComponent
        }, additionalProps), link.pageTitle));
      }));
    }
  }]);
  return SiteMap;
}(_react["default"].Component);

exports["default"] = SiteMap;
SiteMap.propTypes = {
  links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    pageTitle: _propTypes["default"].string.isRequired,
    slug: _propTypes["default"].string.isRequired,
    internal: _propTypes["default"].bool
  })).isRequired,
  bulleted: _propTypes["default"].bool,
  horizontal: _propTypes["default"].bool,
  internalLinkComponent: _propTypes["default"].element
};
SiteMap.defaultProps = {
  bulleted: false,
  internalLinkComponent: null,
  horizontal: false
}; // add prop for choice of link display